import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type DeletePurchaseRequestT = {
  id: string;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({ id, successCallback, errorCallback, resultKey = 'deletePurchaseRequest' }: DeletePurchaseRequestT) =>
  requestAsync({
    url: endpoints.deletePurchaseRequestUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.deletePurchaseRequestUrl(id),
    body: {},
    options: {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
